'use client';

export { default } from './Accordion';
export { default as accordionClasses } from './accordionClasses';
export * from './accordionClasses';